<template>
  <div class="author-item">
    <div class="row m-0 align-items-end justify-content-between">
      <h5 class="m-0">{{author.firstName}} {{author.lastName}}
        <a class="envelope" :href="`mailto:${author.email}`"><icon name="envelope-o"></icon></a>
      </h5>
      <social-media-buttons v-if="!$store.state.isEnhanced" :media-links="author.mediaLinks" class="m-0 hidden-md-down"></social-media-buttons>
    </div>
    <div class="row m-0">
      <div class="col-4 p-0"><img :src="getStaticPath('img/temp/' + author.photoUrl)" /></div>
      <div class="col description">
        <div>{{author.institution}},</div>
        <div>{{author.location}}</div>
        <p>{{author.description}}</p>
        <p>
          <slot name="details-link"></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  import SocialMediaButtons from '@/components/main-layout/shared/SocialMediaButtonsComponent'

  export default {
    name: 'author',
    props: ['author'],
    components: { SocialMediaButtons },
    mixins: [UtilityMixin],
    data () {
      return {
        msg: ''
      }
    }
  }
</script>


<style scoped lang="scss">
  .author-item {
    display: inline-block;
    margin-bottom: 20px;
    width: 49%;
    font-family: 'Open Sans', sans-serif;
    &:nth-of-type(even){
     border-left: 1px solid $grey-border;
     padding-left: 10px;
    }
    .envelope {
      color: inherit;
      margin-left: 10px;
    }
    .description {
      font-family: 'Open Sans Condensed';
      padding: 20px;
      div {
        font-style: italic;
      }
    }
    img {
      max-width: 100%;
    }
    .link {
      font-style: italic;
      cursor: pointer;
      color: $primary-color;
    }
  }

  @media (max-width: $breakpoint-lg) {
    .author-item {
      width: 100%;
      &:nth-child(even){
         border-left: none;
         padding-left: 0px;
         margin-left: 0px;
       }
    }
  }

</style>



// WEBPACK FOOTER //
// AuthorComponent.vue?78faaf40